<template>
  <div class="CreatePropertyComponent">

    <b-form >

      <b-form-group id="input-group-1" :label="lang.label_Name" label-for="input-2">
        <b-form-input
          id="input-Name"
          v-model="form.name"
          :placeholder="lang.placeholder_Name"
          size="sm"
          required
          aria-describedby="input-Name-feedback"
          :state="validation_name"
        ></b-form-input>

        <b-form-invalid-feedback id="input-Name-feedback" :state="validation_name">
          {{lang.validinfo_1}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-2" :label="lang.label_Type" label-for="input-Type">
        <b-form-select
          id="input-Type"
          v-model="form.type"
          :options="types"
          size="sm"
          required
          aria-describedby="input-Type-feedback"
          :state="validation_type"
        ></b-form-select>
        <b-form-invalid-feedback id="input-Type-feedback" :state="validation_type">
          {{lang.validinfo_2}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group v-if="form.type == 'library'" id="input-group-7" :label="lang.label_CategoryLibrary" label-for="input-CategoryId">
          <b-form-select
            id="input-CategoryId"
            v-model="form.libraryCategoryId"
            :options="categories"
            size="sm"
            required
            aria-describedby="input-Type-feedback"
            :state="validation_type"
          ></b-form-select>
          <b-form-invalid-feedback id="input-Type-feedback" :state="validation_libraryCategoryId">
            {{ lang.validinfo_3 }}
          </b-form-invalid-feedback>
        </b-form-group>

      <b-form-group id="input-group-3">
        <b-form-checkbox-group
          v-model="form.checked"
          id="checkboxes-4"

        >
          <b-form-checkbox value="isRequiredOnRequest">{{lang.label_Request}}</b-form-checkbox><br>
          <b-form-checkbox value="isRequiredOnRelease">{{lang.label_Release}}</b-form-checkbox><br>
          <b-form-checkbox value="isRevisionChanging">{{lang.label_Revision}}</b-form-checkbox><br>
          <b-form-checkbox value="isSearchString">{{lang.label_SearchString}}</b-form-checkbox><br>
          <b-form-checkbox value="isNotForDerive">{{lang.label_Non_derivable}}</b-form-checkbox>

          
        </b-form-checkbox-group>

        <span v-if="isCIS">
          <hr>
          <b-form-group id="input-group-5" :label="lang.label_CisDesignation" label-for="input-Designation">
            <b-form-select
              id="input-Designation"
              v-model="form.cisDesignation"
              :options="designationTypes"
              size="sm"
              required
              aria-describedby="input-Designation-feedback"
              :state="validation_designation"
            ></b-form-select>
            <b-form-invalid-feedback id="input-Designation-feedback" :state="validation_designation">
              {{lang.validinfo_4}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-checkbox-group
            v-model="form.checked"
            id="checkboxes-6"
          >
            
            <b-form-checkbox value="cisBrowsable">{{lang.label_CisBrowsable}}</b-form-checkbox>
          </b-form-checkbox-group>
        </span>
        <span v-if="isHDL">
          <hr>
          <b-form-group id="input-group-6" :label="lang.label_HDLDesignation" label-for="input-hdlDesignation">
            <b-form-select id="input-hdlDesignation" v-model="form.hdlDesignation" :options="designationHDLTypes" size="sm" required
              aria-describedby="input-hdlDesignation-feedback" :state="validation_hdlDesignation"></b-form-select>
            <b-form-invalid-feedback id="input-hdlDesignation-feedback" :state="validation_hdlDesignation">
              {{lang.validinfo_5}}
            </b-form-invalid-feedback>
          </b-form-group>
          
        </span>
      </b-form-group>
      

    </b-form>
  </div>
</template>

<script>
//import CreatePropertyComponent from '@/components/shared/CreatePropertyComponent'

import { mapGetters } from 'vuex'

export default {
  name: "CreatePropertyComponent",
  components: {



  },
  props:{
    lang: Object
  },
  data () {
    return {
      form: {

        name: '',
        type: null,
        checked: [],
        hdlDesignation: 4,
        cisDesignation: 2,
        libraryCategoryId: null
      },
      types: [],
      inputStatus: null,
      categories: []
    }
  },
  computed: {
     ...mapGetters({

      appConf: 'appConf',
    }),
    isCIS(){
      return this.$store.getters.appConf.status.isCIS;
    },
    isHDL() {
      return this.$store.getters.appConf.status.isHDL;
    },
    designationTypes(){
            
      const tab = [];
      for (let i = 0, lei = this.lang.CISDesignationTypes.length; i < lei; i++){
                      
        tab.push({value: i, text: this.lang.CISDesignationTypes[i]});
                  
      }
      return tab;
    },
    designationHDLTypes() {

      const tab = [];
      for (let i = 0, lei = this.lang.HDLDesignationTypes.length; i < lei; i++) {

        tab.push({ value: i, text: this.lang.HDLDesignationTypes[i] });

      }
      return tab;
    },
    existingTypes(){
      return this.$store.getters.existingTypes;
    },
    validation_name() {
      if (this.form.name.length == 0){
        return null;
      }
      return this.form.name.length > 0
    },
    validation_type() {
      if (this.form.type == null){
        return null;
      }
      return this.form.type != null
    },
    validation_libraryCategoryId() {
      if (this.form.libraryCategoryId == null) {
        return null;
      }
      return this.form.libraryCategoryId != null
    },
    validation_designation() {
      if (this.form.cisDesignation == null){
        return null;
      }
      return this.form.cisDesignation != null
    },
    validation_hdlDesignation() {
      if (this.form.hdlDesignation == null) {
        return null;
      }
      return this.form.hdlDesignation != null
    }
  },
  mounted() {
    
  },
  created() {

    let _vue = this;
    _vue.types = [];

    this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPropertiesType")
    .then(function(result) {
      
      console.log(result.data)

      if (result.data != null) {
        for (let i = 0, lei = result.data.length; i < lei; i++) {

          
          if (!_vue.existingTypes.includes(result.data[i]) || ((result.data[i] == "text") || (result.data[i] == "link") || (result.data[i] == "library"))) {
            
            if (result.data[i] == "hdl symbol" && _vue.appConf.status.isHDL == false) {
              
            } else {
              
              _vue.types.push({ value: result.data[i], text: result.data[i] });
            }
          } else {
            
            
            if (result.data[i] == "hdl symbol" && _vue.appConf.status.isHDL == false) {
              
              //_vue.types.push({ value: result.data[i], text: result.data[i], disabled: true });
            } else {
              
              _vue.types.push({ value: result.data[i], text: result.data[i], disabled: true });
            }
             
            
          }
        }
        
      }
     

    })

    this.$store.dispatch(this.$store.getters.sectionPrefix + "_getGenericCategories")
      .then(function (result) {

        console.log(result.data)

        if (result.data != null) {
          for (let i = 0, lei = result.data.length; i < lei; i++) {

            let temp = result.data[i].category.split("\\");
            temp.splice(0, 1);

            let text = temp.join('\\');

             _vue.categories.push({ value: result.data[i].categoryId, text: text });
            // if (!_vue.existingTypes.includes(result.data[i]) || ((result.data[i] == "text") || (result.data[i] == "link") || (result.data[i] == "library"))) {
            //   _vue.types.push({ value: result.data[i], text: result.data[i] });
            // } else {
            //   _vue.types.push({ value: result.data[i], text: result.data[i], disabled: true });
            // }

          }
        }


      })
  },
  updated(){
    

    this.$store.dispatch("createPropertyForm", this.form);
    
  },
  methods: {

  }
}
</script>
<style lang="scss">
  .CreatePropertyComponent{
    
  }



</style>



// WEBPACK FOOTER //
// src/components/shared/CreatePropertyComponent.vue